module.exports = __webpack_public_path__ + "img/V9.6dc32f7a.jpg";